{
  "CONFIG_EDITOR": {
    "CREATE_CONFIG": "Create Configuration",
    "ERROR": {
      "ACCOUNT_GROUP_REQUIRED": "Account group is required",
      "NAME_REQUIRED": "Name is required",
      "NO_MATCHING_ACCOUNT_GROUPS_FOUND": "No matching account groups found"
    },
    "NAME": "Name",
    "SOURCE_ACCOUNT_GROUP": "Source Account Group"
  },
  "COMMON": {
    "SAVE": "Save",
    "SAVE_AND_CONTINUE": "Save and continue",
    "NEXT": "Next",
    "BACK": "Back",
    "EDIT": "Edit",
    "CANCEL": "Cancel",
    "CREATE": "Create",
    "APPLY": "Apply",
    "CLOSE": "Close",
    "YES": "Yes",
    "NO": "No"
  },
  "CONFIG_MANAGER": {
    "CREATE_CONFIG": "Create Configuration",
    "CONFIGURATIONS": "Configurations"
  },
  "CONFIG_LIST": {
    "EMPTY_STATE": "No configurations found",
    "EMPTY_STATE_ACTION": "Create a configuration from one account, to apply to others"
  },
  "CONFIG_CARD": {
    "APPLY_TO": "Apply to",
    "SOURCE": "Source",
    "CONTAINS": "Contains",
    "DELETE": "Delete",
    "DELETE_SUCCESS": "Configuration deleted successfully",
    "DELETE_ERROR": "Failed to delete configuration"
  },
  "CONFIG_APPLIER": {
    "TITLE": "Apply Configuration",
    "TARGET_TYPE": "Type",
    "TARGET_TYPE_PLACEHOLDER": "Type",
    "TARGET_NAME": "Name",
    "TARGET_NAME_PLACEHOLDER": "Search for a name",
    "CONTAINER_TYPE": {
      "ACCOUNT_GROUP": "Account Group",
      "MULTI_LOCATION_GROUP": "Multi Location Group"
    },
    "SERVICE_ACCOUNT_SELECTOR_LABEL": "Select Service Account",
    "SERVICE_ACCOUNT_SELECTOR_PLACEHOLDER": "Search for a name",
    "CONFIG_SELECTOR_LABEL": "Select Configuration",
    "CONFIG_OPTIONS_LABEL": "Select Objects to Apply",
    "SUBMISSION_SUCCESS": "Application process started",
    "SUBMISSION_ERROR": "Error applying configuration",
    "NO_ACCOUNTS_ALERT": "Selected companies have no associated accounts",
    "TARGET_SELECTOR_LABEL": "Select Target"
  },
  "CONFIG_DELETE": {
    "TITLE": "Delete Configuration",
    "MESSAGE": "Are you sure you want to delete the following items:"
  }
}
